export default "__VITE_ASSET__BXyoSwnL__"